// Import libs
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

// Import assets
import './ambassadorDetailView.scss';

// Import components
import LenspireView from '../LenspireView';
import { fetchAmbassador } from '../../Base/Actions/ambassadorsActions';
import AuthorModule from '../../Components/Modules/AuthorModule/AuthorModuleView';
import TileContainerController from '../../Components/Tiles/TileContainer/TileContainerController';

class AmbassadorDetailView extends React.Component {
  componentWillMount() {
    this.props.fetchAmbassador(this.props.match.params.lang, { slug: this.props.match.params.ambassador });
  }

  render() {
    return (
      <LenspireView {...this.props} className={'o-ambassador-detail'}>
        <AuthorModule
          {...this.props.ambassadorData}
        />
        <TileContainerController tilesData={this.props.tiles} />
      </LenspireView>
    );
  }
}

function mapStateToProps(state) {
  return {
    meta: state.globalsState.meta,
    error: state.globalsState.error,
    lang: state.globalsState.lang,
    ambassadorData: state.ambassadorsState.activeAmbassador,
    tiles: state.ambassadorsState.tiles,
  };
}

AmbassadorDetailView.propTypes = {
  match: PropTypes.shape().isRequired,
  params: PropTypes.shape(),
  error: PropTypes.string,
  lang: PropTypes.string,
  fetchAmbassador: PropTypes.func.isRequired,
  ambassadorData: PropTypes.shape(),
  tiles: PropTypes.arrayOf(PropTypes.shape()),
};

AmbassadorDetailView.defaultProps = {
  ambassadorData: {},
  tiles: [],
  params: {},
  error: '',
  lang: 'en',
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetchAmbassador }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AmbassadorDetailView);



// WEBPACK FOOTER //
// ./frontend/js/Views/AmbassadorDetailView/AmbassadorDetailView.jsx